/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CancelAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function CancelAction({
  children,
  viewPath = "/App/Account/NewPatient/Content/Panes/Lead/Content/Leads/CancelAction",
  isSubmitting
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let newPatientIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'new_patient',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 marginLeft={dtSpaceS}
 type="secondary"
 block={true}
 data="new_patient"
 disabled={newPatientIsSubmittingData}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../../../Form'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../../../Form'))}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Cancel"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}